
import {
    db
} from '../main'

export default {
    mounted() {
      console.log("hello world!");
    },
    data() {
        return {
            orgUrl: this.$route.params.orgId,
            orgRaw: [],
            org: {},
        }
    },
    watch: {
        orgUrl: {
            // call it upon creation too
            immediate: true,
            handler(orgUrl) {
                if (orgUrl) {
                    const t = this;
                    console.log('org', orgUrl);
                    if(typeof orgId === 'number'){
                        this.$rtdbBind("orgRaw", db.ref('organisations/' + orgUrl)).then(snap => {
                            console.log('org', snap);
                            console.log('orgRaw', t.orgRaw);

                            if (t.orgRaw) {
                                t.org = t.orgRaw
                            } else {
                                this.error = "Organisation " + orgUrl + " not found"
                            }

                            if(t.userObj){
                                t.userObj.organisation = t.org['.key'];
                            }

                            if(t.usersRaw){//Users List page
                                this.$rtdbBind("usersRaw", db.ref('users').orderByChild("organisation").equalTo(parseInt(t.org['.key'],10))).then(snap => {
                                    console.log('snap', snap);
                                    console.log('users from Key', t.usersRaw);
                                })
                            }

                        })
                    }else{
                        this.$rtdbBind("orgRaw", db.ref('organisations').orderByChild('url').equalTo(orgUrl)).then(snap => {
                            console.log('org', snap);
                            console.log('orgRaw', t.orgRaw);

                            if (t.orgRaw[0]) {
                                t.org = t.orgRaw[0]
                            } else {
                                this.error = "Organisation " + orgUrl + " not found"
                            }

                            console.log('t.org', t.org['.key']);

                            if (t.userObj) {
                                t.userObj.organisation = t.org['.key'];
                            }

                            if (t.usersRaw) { //Users List page
                                this.$rtdbBind("usersRaw", db.ref('users').orderByChild("organisation").equalTo(parseInt(t.org['.key'], 10))).then(snap => {
                                    console.log('snap', snap);
                                    console.log('users from Key', t.usersRaw);
                                })
                            }

                        })
                    }
                }
            }
        }
    }
};